import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-category-active",
  "use": "icon-mobile-category-active-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-category-active\">\n<path d=\"M11 2V11H2V2H11ZM9.65 3.35H3.35V9.65H9.65V3.35ZM22 2V11H13V2H22ZM20.65 3.35H14.35V9.65H20.65V3.35ZM11 13V22H2V13H11ZM9.65 14.35H3.35V20.65H9.65V14.35ZM22 13V21.374L20.65 20.003V14.35H14.35V20.65H20.467L20.4621 20.6665L20.462 22H13V13H22Z\" fill=\"#D91D22\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol